import styled from '@emotion/styled';
import Box from '@mui/system/Box';

export const SchedulerWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  nylas-scheduler-editor::part(nse__close-button) {
    display: none;
  }

  nylas-scheduler-editor::part(nse__header) + div {
    display: none;
  }

  nylas-scheduler-editor::part(nse__content) {
    position: relative;
  }

  nylas-scheduler-editor::part(nse__login-required-card) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  nylas-scheduler-editor::part(nlc__create-new-cta) {
    display: none;
  }

  nylas-scheduler-editor::part(editor__footer-cancel.net__footer-cancel) {
    display: none;
  }
`;
